import React, { useState } from 'react';
import { Document, Page } from 'react-pdf';

import image4 from "../../Assets/Img/image4.png"
import image3 from "../../Assets/Img/image3.png"
import image5 from "../../Assets/Img/image5.png"
// import "./Header.scss"
import { Link } from 'react-router-dom';
import BirinchiIkkinchi from '../../Pages/Birinchi_ikkinchi/Birinchi_ikkinchi';
import Yuklangan2 from '../Yuklanganlar2/Yuklanganlar2';
const Header = () => {
  const Oqituvchi = [
    {
      id:1,
      materialName: "o'tkan kunlar 1-qism",
      author: "Abdulla Qodiriy",
      file: "mp3",
      photo: "/image/utkan kunlar.jpg",
      file_name: "/kitoblar/01_otkan_kunlar.mp3",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:2,
      materialName: "onta_negr_bolasi.",
      author: "2-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/onta_negr_bolasi.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:3,
      materialName: "orzularingiz_ogirlanishiga",
      author: "2-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/orzularingiz_ogirlanishiga_jol_qojmang..pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:4,
      materialName: "otkir_hoshimov_tushda",
      author: "1-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/otkir_hoshimov_tushda_kechgan_umirlar.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:5,
      materialName: "pirimqul_qodirov_humoyun",
      author: "1-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/pirimqul_qodirov_humoyun_va_akbar.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:6,
      materialName: "pirimqul_qodirov_humoyun",
      author: "1-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/pirimqul_qodirov_humoyun_va_akbar.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:7,
      materialName: "qaldirgochlar_qoshigi",
      author: "1-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/qaldirgochlar_qoshigi.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:8,
      materialName: "qonun_ustuvorligi_va_inson",
      author: "3-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/qonun_ustuvorligi_va_inson_manfaatlarini_taminlash__yurt_taraqqiyoti_va_xalq_farovonligining_garovi.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:9,
      materialName: "sariq_devni_minib",
      author: "3-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/sariq_devni_minib.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:10,
      materialName: "shajtanat",
      author: "3-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/shajtanat.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:11,
      materialName: "shovqin_erkin_azam_",
      author: "3-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/shovqin_erkin_azam_.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:12,
      materialName: "tanqidiy_tahlil_qatiy_tartib-intizom_va_shaxsiy_javobgarlik",
      author: "3-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/tanqidiy_tahlil_qatiy_tartib-intizom_va_shaxsiy_javobgarlik__har_bir_rahbar_faoliyatining_kundalik_qoidasi_bolishi_kerak.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:13,
      materialName: "usmon_azim._sajlanma_",
      author: "3-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/usmon_azim._sajlanma_.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:14,
      materialName: "xurshid_davron_bibixoni",
      author: "3-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/xurshid_davron_bibixoni_qissasi..pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:15,
      materialName: "zulfiya_yana_bahor_hokim",
      author: "3-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/zulfiya_yana_bahor_hokim.mp3",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:16,
      materialName: "yodgor",
      author: "3-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/yodgor.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:17,
      materialName: "yulduzli_tunlar",
      author: "3-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/yulduzli_tunlar.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:18,
      materialName: "zaxarli_hayot_yohud_ishq",
      author: "3-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/zaxarli_hayot_yohud_ishq__qurbonlari..pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:19,
      materialName: "zhek_london_martin_iden",
      author: "3-kurs talabasi",
      file: "docx",
      photo: "",
      file_name: "/kitoblar/zhek_london_martin_iden.pdf",
      roll: ['student'],
      categories: ['student']
    },
  ]
  const arxiv = [
    {
      materialName: "Yuz Mumtoz Faylasuf",
      author: "Saida Jo'rayeva",
      file: "pdf",
      photo: "https://kitobxon.com/img_knigi/4205.jpg",
      file_name: "/kitoblar/100_mumtoz_faylasuf.pdf",
      file_name: "/kitoblar/100_mumtoz_faylasuf.pdf",
      roll: ['student'],
      categories: ['student']
    },

    {
      materialName: "Abay she'rlar va poemalari",
      author: "Abay",
      file: "pdf",
      photo: "../image/abay.jpg",
      file_name: "../kitoblar/abay_sherlar_va_poemalar.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      materialName: "O'lmas Umarbekov.Kimning tashvishi yo'q ",
      author: "O'lmas Umarbekov",
      file: "pdf",
      photo: "../image/abay.jpg",
      file_name: "../kitoblar/O'lmasUmarbekov.Kimningtashvishiyo'q.pdf",
      roll: ['student'],
      categories: ['student']
    },

    {
      materialName: "Yillar Sadosi",
      author: "Zulfiya",
      file: "pdf",
      photo: "../image/",
      file_name: "../kitoblar/zulfiya_yillar_sadosi.pdf",
      roll: ['student'],
      categories: ['student']
    },


    {
      materialName: "Suq",
      author: "Zufiya",
      file: "pdf",
      photo: "../image/",
      file_name: "../kitoblar/zulfiya_suq.mp3",
      roll: ['student'],
      categories: ['student']
    },
    {
      materialName: "Yillar Sadosi",
      author: "Zulfiya",
      file: "pdf",
      photo: "../image/",
      file_name: "../kitoblar/zulfiya_yillar_sadosi.pdf",
      roll: ['student'],
      categories: ['student']
    },


    {
      materialName: "Suq",
      author: "Zufiya",
      file: "pdf",
      photo: "../image/",
      file_name: "../kitoblar/zulfiya_suq.mp3",
      roll: ['student'],
      categories: ['student']
    },
    {
      materialName: "O'yla va boy bo'l",
      author: "Ahmad Muhammad Tursun",
      file: "pdf",
      photo: "../image/",
      file_name: "../kitoblar/O'ylavaboybo'l.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      materialName: "Tog ay Murod. Otamdan qolgan dalalar (roman)",
      author: "Ahmad Muhammad Tursun",
      file: "pdf",
      photo: "../image/",
      file_name: "../kitoblar/TogMurodOtamdanqolgandalalar(roman).pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      materialName: "Millioner singari fikrlashni o‘rganing",
      author: "Ahmad Muhammad Tursun",
      file: "pdf",
      photo: "../image/",
      file_name: "../kitoblar/Millionersingarifikrlashnio‘rganing.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      materialName: "Aleksandr Pushkin. Kapitanqizi(qissa)",
      author: "Ahmad Muhammad Tursun",
      file: "pdf",
      photo: "../image/",
      file_name: "../kitoblar/AleksandrPushkin.Kapitanqizi(qissa).pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      materialName: "Nabijon Hoshimov-Chayonlar so`qmog`i",
      author: "Nabijon Hoshimov",
      file: "pdf",
      photo: "../image/",
      file_name: "../kitoblar/NabijonHoshimov-Chayonlarso`qmog`i.doc",
      roll: ['student'],
      categories: ['student']
    },
  ]
  const app = [
    {
      id: 1,
      materialName: "MPCHC.exe",
      author: "",
      file: "app",
      photo: "",
      file_name: "/app/MPCHC",
      roll: ['student'],
      categories: ['public']
    },
    {
      id: 2,
      materialName: "pdf-cracker-setup",
      author: "",
      file: "app",
      photo: "",
      file_name: "/app/pdf-cracker-setup.exe",
      roll: ['student'],
      categories: ['public']
    },
    {
      id: 3,
      materialName: "Photoshop",
      author: "",
      file: "app",
      photo: "",
      file_name: "/app/Photoshop.exe",
      roll: ['student'],
      categories: ['public']
    },
    {
      id: 4,
      materialName: "PotPlayer",
      author: "",
      file: "app",
      photo: "",
      file_name: "/app/PotPlayer.exe",
      roll: ['student'],
      categories: ['public']
    },
    {
      id: 5,
      materialName: "Rufus 2.6",
      author: "",
      file: "app",
      photo: "",
      file_name: "/app/Rufus2.6.exe",
      roll: ['student'],
      categories: ['public']
    },

  ]
  const [student, setStudent] = useState(Oqituvchi)
  console.log(student);
  return (
    <div>
      <div className='header' style={{ display: "flex", justifyContent: "center", margin: "40px auto" }}>
        <h1>Mening malumotlarim!</h1>
        <div className='header__render'>
          <Link to="/BirinchiIkkinchi2" className='card'>
            <img className='card__img' src={image4} alt="" />
            <h2>{student.length}</h2>
            <h4>1-2-3-4 kurs materiallari</h4>
          </Link>
          <Link to="/Arxiv2" className='card'>
            <img className='card__img' src={image3} alt="" />
            <h2>{arxiv.length}</h2>
            <h4>Raqamli arxiv</h4>
          </Link>
          <Link to="/OqtuvchiApp" className='card'>
            <img className='card__img' src={image5} alt="" />
            <h2>{app.length}</h2>
            <h4>Dasturiy ta'minot</h4>
          </Link>
        </div>
      </div>
      <Yuklangan2/>
    </div>
  );
}

export default Header;
